<template>
  <div id="app">
    <Error403 v-if="$store.state.error403" />
    <PageNotFound v-else-if="$store.state.error404" />
    <Error429 v-else-if="$store.state.error429" />
    <Error500 v-else-if="$store.state.error500" />
    <router-view v-else :key="$route.fullPath" />
  </div>
</template>

<script>
import Error403 from '@/components/Error403'
import Error429 from '@/components/Error429'
import Error500 from '@/components/Error500'
import PageNotFound from '@/views/PageNotFound'

export default {
  components: { Error403, Error429, Error500, PageNotFound },
}
</script>

<style>
#app {
  @apply font-avenir text-main-500 text-center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
